import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import HeaderSort from 'PyzShopUi/scripts/shop-ui/components/search-page/components/header/HeaderSort';
import NativeLanguageSelect
    from 'PyzShopUi/scripts/product-review/components/product-review-list/header/NativeLanguageSelect';
import {ISelectOption} from 'PyzShopUi/scripts/shop-ui/interfaces';

interface IHeaderProps {
    itemLanguageOptions: ISelectOption[];
    currentItemsLanguage: string;
    sortParamNames: string[];
    currentSortParam: string;
    dispatch: React.Dispatch<any>;
}

const Header: React.FunctionComponent<IHeaderProps> = props => {
    const {
        itemLanguageOptions,
        currentItemsLanguage,
        sortParamNames,
        currentSortParam,
        dispatch
    } = props;

    const { translate } = useTranslationHook();

    const displaySort = () => {
        return (
            <div className="result-header__sort hide-for-small-only bold">
                <HeaderSort
                    label={translate('Sort by', { ns: 'article-list' })}
                    sortParamNames={sortParamNames}
                    currentSortParam={currentSortParam}
                    dispatch={dispatch}
                />
            </div>
        )
    }

    const displayLanguageSelect = () => {
        if (!itemLanguageOptions.length) {
            return null;
        }

        return (
            <div className="result-header__item hide-for-small-only bold">
                <NativeLanguageSelect
                    label={translate('Review by language', { ns: 'article-detail' })}
                    itemLanguageOptions={itemLanguageOptions}
                    currentItemsLanguage={currentItemsLanguage}
                    dispatch={dispatch}
                />
            </div>
        );
    }

    return (
        <React.Fragment>
            <div>
                {displayLanguageSelect()}
            </div>
            <div>
                {displaySort()}
            </div>
        </React.Fragment>
    );
};

export default Header;
